import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import Modal from '../../../common/modal/Modal';
import BillReversionForm from './BillReversionForm';
import { postBillingReversion } from '../../../../actions';
import { BILLING_REPORT_RETENTION_PATH } from '../../../../config/paths';

const BillReversionButton = ({
  dispatchpostBillingReversion,
  billing,
  dispatchPush,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');

  const onModalSubmit = async (formValues) => {
    const payload = {
      refDocumentSeries: billing.get('documentSeries'),
      refDocumentCode: billing.get('documentCode'),
      reasonDescription: formValues.comment,
    };

    const response = await dispatchpostBillingReversion(payload);

    if (response) {
      dispatchPush(BILLING_REPORT_RETENTION_PATH);

      setModalBody(null);
      setShowModal(false);
    }
  };

  const openModal = async () => {
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const buildModalBody = () => {
    const newModalBody = (
      <BillReversionForm onCancel={closeModal} onSubmit={onModalSubmit} />
    );
    setModalBody(newModalBody);
  };

  useEffect(() => {
    if (showModal !== false) {
      buildModalBody();
    }
  }, [showModal]);

  return (
    <>
      <Modal
        show={showModal}
        title="Generar Reversión de Retención"
        body={modalBody}
        size="xl"
        onClickCancel={closeModal}
        onClickClose={closeModal}
      />
      <Button color="info" onClick={openModal}>
        <i className="fa fa-pencil" /> Generar Reversión
      </Button>
    </>
  );
};

BillReversionButton.propTypes = {
  dispatchpostBillingReversion: PropTypes.func.isRequired,
  billing: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchPush: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchpostBillingReversion: postBillingReversion,
  dispatchPush: push,
};

export default connect(null, mapDispatchToProps)(BillReversionButton);
